import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGameList, getallClassify, deledMsg } from "@/api/dataAll/gamestyle";
import gameStyle from "./components/addGameStyle";
export default {
  name: "gameStyle",
  components: {
    gameStyle: gameStyle
  },
  data: function data() {
    return {
      total: 0,
      pagrSize: 10,
      searchData: {
        page: 1,
        classify: ''
      },
      tableData: [],
      addWayConfig: false,
      showing: false,
      classifyData: []
    };
  },
  created: function created() {
    var _this = this;

    getallClassify().then(function (res) {
      _this.classifyData = res.data;
    });
  },
  methods: {
    classifychange: function classifychange(val) {
      this.searchMark.classify = val;
    },
    searchClick: function searchClick() {
      var _this2 = this;

      getGameList(this.searchMark).then(function (res) {
        _this2.tableData = res.data.data || [];
        _this2.total = res.data.total - 0 || 0;
      });
    },
    handleSource: function handleSource(id, num) {
      var _this3 = this;

      this.addWayConfig = true;
      this.showing = true;
      this.$nextTick(function () {
        _this3.$refs.addWayConfig.init(id, num);
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchData.page = val;
      this.searchClick();
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm("此操作将删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deledMsg({
                  id: id
                }).then(function (res) {
                  _this4.searchClick();
                });

                _this4.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};